/* AgentCardSkeleton.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1xC2CJa6YE%7Bgrid-area%3Acontent%7D%0A._4xdlr07p2s%7Balign-self%3Astart%7D%0A._4ouGXIdnbC%7Bmin-width%3A0%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._0jFU0VoWWg%7Bheight%3A24px%7D%0A._0jFU0Vey7F%7Bheight%3A1pc%7D%0A._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._0bjKvDyzSk%7Bborder-radius%3Avar(--ds-radius-xlarge%2C9pt)%7D%0A._2V7sgONvrM%7Bborder-width%3Avar(--ds-border-width%2C1px)%7D%0A._3hxITi6wH8%7Bborder-style%3Asolid%7D%0A._3vBAKH9r67%7Bborder-color%3Avar(--ds-border%2C%230b120e24)%7D%0A._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D%0A._0jFU0VN91d%7Bheight%3A100%25%7D%0A._39xV02N91d%7Bwidth%3A100%25%7D%0A._0KLXrulfZc%7Bbackground-color%3Avar(--ds-surface%2C%23fff)%7D%0A._3iDTPbgBM8%7Bdisplay%3Agrid%7D%0A._2iEGP28wUV%7Bgrid-template-columns%3Aminmax(0%2C1fr)%7D%0A._0ca6V7uqJ7%7Bgrid-template-rows%3Aauto%20auto%20auto%7D%0A._3NN0tObcaY%7Bgrid-template-areas%3A%22cover%22%20%22content%22%20%22metadata%22%7D%0A._42d1HA8HPE%7Brow-gap%3Avar(--ds-space-150%2C9pt)%7D%0A._1xC2CJiObl%7Bgrid-area%3Acover%7D%0A._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._0jFU0VmdCj%7Bheight%3A56px%7D%0A._1mT5xdWVPG%7Bposition%3Aabsolute%7D%0A._2I62gzPgdg%7Binset-block-start%3Avar(--ds-space-0%2C0)%7D%0A._1ZB6Uy5zaO%7Binset-block-end%3Avar(--ds-space-200%2C1pc)%7D%0A._3iC0zdPgdg%7Binset-inline-start%3Avar(--ds-space-0%2C0)%7D%0A._1OKFqYPgdg%7Binset-inline-end%3Avar(--ds-space-0%2C0)%7D%0A._42Yu6B7dHp%7Bz-index%3A1%7D%0A._2iEGP2cMcx%7Bgrid-template-columns%3Aauto%20minmax(0%2C1fr)%7D%0A._0GwItXDIqT%7Balign-content%3Acenter%7D%0A._0Of8r2kG2W%7Bpadding-top%3Avar(--ds-space-250%2C20px)%7D%0A._1Znuxb5zaO%7Bpadding-right%3Avar(--ds-space-200%2C1pc)%7D%0A._2Zuz6Q5zaO%7Bpadding-left%3Avar(--ds-space-200%2C1pc)%7D%0A._1xC2CJphCm%7Bgrid-area%3Ametadata%7D%0A._313842IZbP%7Bmargin-top%3Aauto%7D%0A._1wydGW5zaO%7Bpadding-bottom%3Avar(--ds-space-200%2C1pc)%7D");






































import React from 'react';
import AvatarSkeleton from '@atlaskit/avatar/skeleton';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import Skeleton from '@atlaskit/skeleton';
import { Card } from '../../../common/ui/Card/Card';
import { CardAvatarFrame } from '../../../common/ui/Card/CardAvatarFrame';
import { CardCover } from '../../../common/ui/Card/CardCover';
import { CardFooter } from '../../../common/ui/Card/CardFooter';
const styles = {
  loadingContent: "_1xC2CJa6YE _4xdlr07p2s _4ouGXIdnbC",
  titleLine: "_3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VoWWg",
  textLine: "_3iDTPbQ4SZ _0hPCNLDIqT _0jFU0Vey7F",
  root: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDyzSk _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _24h04i2Njc _0jFU0VN91d _39xV02N91d _0KLXrulfZc _3iDTPbgBM8 _2iEGP28wUV _0ca6V7uqJ7 _3NN0tObcaY _42d1HA8HPE",
  cover: "_1xC2CJiObl _1mT5xdRAKS _39xV02N91d _0jFU0VmdCj",
  coverBackground: "_1mT5xdWVPG _2I62gzPgdg _1ZB6Uy5zaO _3iC0zdPgdg _1OKFqYPgdg",
  coverForeground: "_1mT5xdRAKS _42Yu6B7dHp _24h04i2Njc _3iDTPbgBM8 _39xV02N91d _0jFU0VN91d _2iEGP2cMcx _0GwItXDIqT _0hPCNLDIqT _0Of8r2kG2W _1Znuxb5zaO _2Zuz6Q5zaO",
  content: "_1xC2CJa6YE _4ouGXIdnbC _1Znuxb5zaO _2Zuz6Q5zaO",
  metadata: "_1xC2CJphCm _4ouGXIdnbC _313842IZbP _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO"
};
export type AgentCardSkeletonProps = {
  testId?: string;
};
const LoadingAvatar = (): React.JSX.Element => <CardAvatarFrame>
		<AvatarSkeleton size="xlarge" appearance="hexagon" color={"var(--ds-text, #292A2E)"} />
	</CardAvatarFrame>;
export const AgentCardSkeleton = ({
  testId
}: AgentCardSkeletonProps): React.JSX.Element => {
  if (fg('rovo_agents_studio_browse_kit_uplift')) {
    return <Card aria-hidden="true" hasCutout isDisabled testId={testId}>
				<CardCover name="" avatar={LoadingAvatar} coverStyle="plain" testId={testId ? `${testId}--cover` : undefined} />
				<Stack xcss={styles.loadingContent} space="space.150" testId={testId ? `${testId}--content` : undefined}>
					<Stack>
						<Box xcss={styles.titleLine}>
							<Skeleton width="70%" height={16} />
						</Box>
						<Box xcss={styles.textLine}>
							<Skeleton width="45%" height={12} />
						</Box>
					</Stack>
					<Stack>
						<Box xcss={styles.textLine}>
							<Skeleton width="100%" height={12} />
						</Box>
						<Box xcss={styles.textLine}>
							<Skeleton width="80%" height={12} />
						</Box>
					</Stack>
				</Stack>
				<CardFooter testId={testId ? `${testId}--footer` : undefined}>
					<Skeleton width={24} height={24} borderRadius={"var(--ds-radius-medium, 6px)"} />
					<Skeleton width={24} height={24} borderRadius={"var(--ds-radius-medium, 6px)"} />
				</CardFooter>
			</Card>;
  }
  return <Box xcss={styles.root} aria-hidden="true" testId={testId}>
			<Box xcss={styles.cover} testId={testId ? `${testId}--cover` : undefined}>
				<Box xcss={styles.coverBackground}>
					<Skeleton width="100%" height="100%" borderRadius={0} isShimmering />
				</Box>
				<Box xcss={styles.coverForeground}>
					<Skeleton width={32} height={32} isShimmering />
				</Box>
			</Box>

			<Box xcss={styles.content} testId={testId ? `${testId}--content` : undefined}>
				<Stack space="space.075">
					<Inline space="space.075" alignBlock="center">
						<Skeleton width={112} height={20} isShimmering />
						<Skeleton width={16} height={16} isShimmering />
					</Inline>
					<Stack space="space.025">
						<Skeleton width="100%" height={16} isShimmering />
					</Stack>
				</Stack>
			</Box>

			<Box xcss={styles.metadata} testId={testId ? `${testId}--metadata` : undefined}>
				<Inline space="space.075" alignBlock="center">
					<Skeleton width={72} height={16} isShimmering />
					<Skeleton width={16} height={16} isShimmering />
					<Skeleton width={32} height={16} isShimmering />
				</Inline>
			</Box>
		</Box>;
};